import React from 'react';
import { PropTypes } from 'prop-types';

import { buildDescription } from 'components/IndividualValidationResult';

/* eslint-disable max-len, react/no-array-index-key */
export const RedFlagsCellRenderer = ({ value: warnings }) => (
  <div className="red-flags-and-recs-list">
    { warnings != null && warnings.length === 0 && <span>N/A</span> }
    { warnings != null && warnings.length !== 0 && <ul>
      { warnings.sort(({ code: a }, { code: b }) => {
        if (a.indexOf('WRN') === 0 && b.indexOf('REC') === 0) {
          return -1;
        }
        if (b.indexOf('WRN') === 0 && a.indexOf('REC') === 0) {
          return 1;
        }
        return 0;
      }).map(warning => (warning != null
        && <li
          key={ warning.key }
          className={ `${ warning.code && warning.code.indexOf('WRN') === -1 ? 'recommendation' : 'red-flag' }` }
        >
          { buildDescription(warning) }
          &nbsp;({ warning.code })</li>
      )) }
    </ul> }
  </div>
);
/* eslint-enable max-len, react/no-array-index-key */

RedFlagsCellRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    codeDescription: PropTypes.string,
    context: PropTypes.shape({}),
    key: PropTypes.string
  })).isRequired
};

export function getRedFlagsForFilter({ value: warnings }) {
  return (
    warnings != null && warnings.map(({
      code,
      codeDescription,
      contextValue
    }) => code != null && codeDescription != null && (
      `${ code } ${ codeDescription } ${ contextValue != null ? contextValue.value : null }`
    )).join(' ')
  );
}
